// Module
var code = `<div class="accountLookupDropDownForm">
    <div class="header_acc_lookupDropDownForm">
        <terceraTextBox name="textBox" additionalClass="textBox_acc_lookupDropDownForm" isMaterialDesign="false" svgIcon="search"/>
        <div class="account-lookup-header-filter" style="{{#if !isMultiSelectMode}}display: none;{{/if}}">
            {{#if isMultiSelectMode}}
            <reactFormLabel label="{{.multiSelectText}}">
                <reactCheckbox 
                    checked="{{.isMultiSelect}}" 
                    on-onChange="@this.onMultiSelectChanged(\$1)" />
            </reactFormLabel>
            {{/if}}
        </div>
    </div>

    <div class="body_acc_lookupDropDownForm">
        <terceraQuickTree name="quickTree" boldRootNode="false" />
    </div>

    <div class="footer_acc_lookupDropDownForm" {{^.isShowFooterBtn}}style="display: none;" {{/}}>
        <div class="checkBoxContainer_acc_lookupDropDownForm">
            <reactFormLabel label="{{.selectAllText}}">
                <reactCheckbox 
                    checked="{{.checkedSelectedAll}}" 
                    on-onChange="@this.onCheckAllStateChange(\$1)"/>
            </reactFormLabel>
        </div>
        <div class="addCancelBtnContainer_acc_lookupDropDownForm">
            <terceraButton name="addBtn" terceraButtonStyle="js-button-gray25 style-width-100" on-componentClick="@this.onAddBtnClicked(true)" enabled="{{.enabledAddBtn}}" text="{{.addBtnText}}" />
            <terceraButton terceraButtonStyle="js-button-gray25 style-width-100" on-componentClick="@this.close()" text="{{.cancelBtnText}}" />
        </div>
    </div>
</div>`;
// Exports
export default code;